import { BOH_TRANSACTIONS_DELETE_REQUEST, BOH_TRANSACTIONS_DELETE_SUCCESS, BOH_TRANSACTIONS_DELETE_FAILURE } from './types/BalanceModificationTransactionsDeleteActionsTypes';

export function deleteBalanceModificationTransactionsDeleteRequestActionCreator(context,
  newComments,
  newTransactionId) {
  return {
    type: BOH_TRANSACTIONS_DELETE_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newComments,
        transactionId: newTransactionId,
      },
    },
  };
}

export function deleteBalanceModificationTransactionsDeleteSuccessActionCreator(data) {
  return {
    type: BOH_TRANSACTIONS_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteBalanceModificationTransactionsDeleteFailureActionCreator(error) {
  return {
    type: BOH_TRANSACTIONS_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
